import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocalisationService } from '@app/services/localisation.service';

@Component({
  selector: 'app-connection-error',
  templateUrl: './connection-error.component.html',
  styleUrls: ['./connection-error.component.scss']
})
export class ConnectionErrorComponent implements OnInit {
  @Input()
  errorMessage: string;
  @Output()
  click = new EventEmitter();

  locale: any;

  constructor(private localisation: LocalisationService) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('ConnectionErrorComponent');

    if (!this.errorMessage) {
      this.errorMessage = this.locale.defaultError;
    }
  }

  onButtonClicked() {
    this.click.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/connection-error/connection-error.component.ts